import {css} from 'aphrodite';
import React from 'react';

import {BenchlingExpressionType} from 'benchling-expressions/BenchlingExpressionTypes';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {
  sharedStyles,
  ConditionalLogicAllowedValuesBaseProps,
} from 'processes/modals/router-config/RouterConfigConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import TextInput from 'ui-library/inputs/TextInput';

export interface ConditionalLogicAllowedValuesProps extends ConditionalLogicAllowedValuesBaseProps {
  dataTestAttrs?: DataTestAttrs;
}

export default function ConditionalLogicValueText(
  props: ConditionalLogicAllowedValuesProps
): JSX.Element | null {
  const typeDef = props.constantExpression?.itemType?.name ?? null;
  const isCompatible = typeDef == null || typeDef === LeafType.TEXT;

  const evaluateExpressionValue = (value: unknown): string | undefined => {
    if (typeof value === 'string') {
      return value;
    }

    return undefined;
  };

  return (
    <TextInput
      className={css(sharedStyles.routerInputControl)}
      value={evaluateExpressionValue(props.constantExpression?.value) ?? ''}
      placeholder="enter text"
      disabled={!isCompatible}
      onChange={(e) => {
        const newParam = {
          name: props.expression?.parameters?.[1]?.name,
          expression: {
            type: BenchlingExpressionType.CONSTANT_VALUE,
            itemType: {
              name: LeafType.TEXT,
            },
            value: e.target.value.length > 0 ? e.target.value : undefined,
          },
        };
        const newExpression = {
          ...props.expression,
          parameters: [props.expression?.parameters?.[0], newParam],
        };

        props.setExpression(newExpression);
      }}
      dataTestAttrs={{component: 'ConditionalLogicValueText', element: 'root'}}
    />
  );
}
